/* src/app/main/pages/apps/inco-terms/inco-terms.component.css */
.app-img {
  width: 65px;
  height: 65px;
}
.back-link {
  color: #E8882D;
  font-family: "D-DIN";
  font-size: 16px;
}
.back-link .fa-angle-left {
  font-weight: 600;
}
.apps-form-input {
  background-color: #213654;
  padding: 8px 10px;
  margin-top: 30px;
  margin-bottom: 15px;
  box-shadow: 0px 3px 6px #00000029;
}
.apps-form-input label {
  margin-right: 10px;
  margin-bottom: 0px;
  font-weight: 600;
}
.apps-form-input .form-control {
  font-size: 15px;
  height: auto;
  border-radius: 0;
  padding: 3px 10px;
  border: none;
  margin-right: 10px;
  font-family: "D-DIN";
  width: 84%;
}
.emission-calculator .form-control {
  font-size: 14px;
  height: auto;
  border-radius: 0;
  padding: 8px 12px;
  border: none;
  font-family: "Roboto";
  border-radius: 0;
  background-color: #F0F0F0;
  border-left: 3px solid #0B2A7D !important;
  border: 1px solid rgb(11 42 125 / 0.2);
}
.emission-calculator .btn-search {
  background-color: #E8882D;
  border: none;
  color: #FFFFFF;
  border-radius: 0px;
  box-shadow: 0px 3px 6px #00000029;
  font-size: 14px;
  padding: 8px 36px;
  font-family: "D-DIN-Bold";
  margin-right: 60px;
}
.bg-gray {
  background-color: #F5F5F5;
  box-shadow: 0px 3px 6px #00000029;
}
.box-shape {
  background-color: #EFF1F4;
  padding: 15px 18px;
  box-shadow: 0px 3px 6px #00000029;
  transform: skew(20deg);
  margin-left: 10px;
  text-align: center;
}
.box-shape:last-child {
  margin-right: 10px;
}
.box-shape img,
.box-shape p {
  transform: skew(-20deg);
}
.box-shape img {
  width: 40px;
  height: 35px;
}
.box-shape p {
  background-color: #213654;
  position: absolute;
  width: 100%;
  bottom: -19px;
  left: -3px;
  color: #fff;
  font-size: 12px;
}
.inco-terms-divider {
  margin-top: 3rem;
}
.main-divider {
  margin-top: 10px;
  margin-bottom: 20px;
}
.fcl-progress-bar .progress {
  background-color: #e8882d6e;
  border-radius: 0;
}
.fcl-progress-bar .progress-bar-1 {
  width: 23%;
  background-color: #e8882d;
}
.fcl-progress-bar .progress-bar-2 {
  width: 2px;
  background-color: #171717;
}
.free-carrier-progress-bar .progress {
  background-color: #9FB1D0;
  border-radius: 0;
}
.free-carrier-progress-bar .progress-bar-1 {
  width: 30%;
  background-color: #20366E;
}
.free-carrier-progress-bar .progress-bar-2 {
  width: 2px;
  background-color: #171717;
}
.chart-unit .cell {
  font-size: 13px;
  padding-bottom: 10px;
}
.chart-unit .color {
  float: left;
  width: 14px;
  height: 14px;
  margin-right: 7px;
}
.chart-unit .color.red {
  background: #e8882d;
}
.chart-unit .color.blue {
  background: #20366E;
}
.chart-unit .color.black {
  background: #171717;
}
.chart-unit .color.red-light {
  background: #e8882d6e;
}
.chart-unit .color.blue-light {
  background: #9FB1D0;
}
.cnt-us {
  background-color: #FFEBD8;
  padding: 10px 20px;
}
.cnt-us .btn {
  background-color: #E8882D;
  color: #fff;
  border-radius: 0;
  box-shadow: 0px 3px 6px #00000029;
  padding: 4px 15px;
  font-size: 14px;
}
.vl {
  width: 1px;
  background-color: #dee2e6;
  height: 100%;
  margin: 0 auto;
}
@media (min-device-width: 1920px) {
  .chart-unit .color {
    width: 21px;
    height: 21px;
  }
  .chart-unit .cell {
    font-size: 20px !important;
  }
}
@media (min-device-width: 1680px) {
  .box-shape {
    padding: 16px 23px !important;
  }
  .box-shape p {
    font-size: 14px !important;
  }
}
@media (min-device-width: 1600px) {
  .chart-unit .cell {
    font-size: 17px;
  }
  .box-shape img {
    width: 50px;
    height: 45px;
  }
  .box-shape {
    padding: 16px 21px;
  }
  .box-shape p {
    font-size: 14px;
  }
}
@media (min-device-width: 1440px) {
  .inco-terms .app-img {
    width: 75px;
    height: 75px;
  }
  h2 {
    font-size: 46px;
  }
  .back-link {
    font-size: 24px !important;
  }
  .apps-form-input label {
    font-size: 20px;
  }
  .apps-form-input {
    padding: 12px 10px;
  }
  .apps-form-input .form-control {
    font-size: 20px;
  }
  .bg-gray p {
    font-size: 21px;
  }
  .cnt-us .btn {
    font-size: 18px;
  }
  .box-shape p {
    font-size: 12px;
  }
}
@media (device-width: 1440px) {
  h2 {
    font-size: 45px;
  }
  .chart-unit .cell {
    font-size: 13px;
  }
}
@media (max-width: 768px) {
  .sm-border-none {
    border-right: none !important;
  }
  .box-shape p {
    font-size: 11px;
    bottom: -17px;
  }
}
@media (max-width: 767px) {
  .apps-form-input {
    padding: 15px 10px;
  }
  .apps-form-input label,
  .apps-form-result label {
    width: 100%;
  }
  .apps-form-input label {
    margin-bottom: 15px;
  }
  .apps-form-input .form-group {
    text-align: center;
  }
  .apps-form-input .form-control {
    width: 100%;
  }
  .res-mb-0 {
    margin-bottom: 0px;
  }
  .res-hor-scroll {
    overflow-x: scroll;
    height: 130px;
    padding-left: 5px;
  }
  .box-shape {
    padding: 0px 0px;
    min-width: 77px;
    min-height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cnt-us .btn {
    margin-top: 15px;
  }
  .res-text-center {
    text-align: center;
  }
  .bg-gray {
    margin-bottom: 30px;
  }
  .card-img-top {
    margin-top: 10px;
  }
  .inco-terms .back-link {
    margin-bottom: 5px;
  }
  .apps-form-input {
    padding: 15px 10px;
  }
}
.loader {
  position: absolute;
  background-color: #cccccc6e;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0px;
}
.loader-icon {
  position: absolute;
  width: 50px;
  height: 50px;
  margin: auto;
  text-align: center;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left: 0px;
}
.incotermDetails {
  position: relative;
}
.in-rows-right .ic-line {
  position: relative;
}
.in-rows-right .ic-line .level {
  color: #fff;
  font-size: 12px;
  line-height: 12px;
  text-align: right;
  position: absolute;
}
.in-rows-right .ic-line.black {
  background: #fff;
}
.in-rows-right .ic-line.black .level {
  background: #333;
  color: #fff;
  font-size: 12px;
  line-height: 12px;
  text-align: left;
}
.in-rows-right .ic-line .level.three {
  width: 253px;
}
.step4 {
  left: 295px;
}
.border-right {
  border-right: 1px solid #dee2e6 !important;
}
/*# sourceMappingURL=inco-terms.component.css.map */
